import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCode,FiDatabase,FiCloud,FiCpu}=FiIcons;

const SkillsSection=()=> {
  const roles=[
    {
      icon: FiCode,
      title: 'Software Engineer',
      color: 'from-green-500 to-teal-500',
      skills: [
        'C# och .NET - Många svenska företag använder Microsoft-stacken',
        'Azure - Lär dig en molnplattform grundligt, sedan kan du andra',
        'Frontend: Angular och React - Sträva efter att vara fullstack',
        'Generativ AI som CoPilot - Använd som parprogrammerare'
      ],
      future: 'Framtidens software engineer får mer tid att prata med kund och skapa värde medan AI hjälper med kodning.'
    },
    {
      icon: FiDatabase,
      title: 'Data Engineer',
      color: 'from-blue-500 to-indigo-500',
      skills: [
        'SQL och Python - Grundstenarna för datahantering',
        'Azure Data Services och Microsoft Fabric - Börja med en plattform',
        'Dataintegration och ETL-processer',
        'Generativ AI för dataimport och filtrering'
      ],
      future: 'Data är det nya guldet. Som Data Engineer ser du till att sortera och förbereda data för analys och AI.'
    }
  ];

  const certifications=[
    'AI-200 för Software Engineer',
    'AI-103 för Azure AI Engineer Associate',
    'DP-700 för Data Engineer',
    'Visa att du kan slutföra uppgifter',
    'Bygg ditt personliga varumärke'
  ];

  return (
    <section id="skills" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="text-center mb-16"
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.6}}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Tekniska kompetenser{' '}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              framåt
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Fokusera på dessa teknologier baserat på den svenska marknaden och större företag
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {roles.map((role,index)=> (
            <motion.div
              key={index}
              className="bg-white rounded-2xl shadow-xl overflow-hidden"
              initial={{opacity: 0,x: index===0 ? -50 : 50}}
              whileInView={{opacity: 1,x: 0}}
              viewport={{once: true}}
              transition={{duration: 0.8,delay: index * 0.2}}
            >
              <div className={`bg-gradient-to-r ${role.color} p-6 text-white`}>
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <SafeIcon icon={role.icon} className="w-6 h-6" />
                  </div>
                  <h3 className="text-2xl font-bold">{role.title}</h3>
                </div>
              </div>
              <div className="p-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-4">Viktiga färdigheter:</h4>
                <ul className="space-y-3 mb-6">
                  {role.skills.map((skill,skillIndex)=> (
                    <li key={skillIndex} className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-gray-700">{skill}</span>
                    </li>
                  ))}
                </ul>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-800 mb-2">Framtidsperspektiv:</h5>
                  <p className="text-gray-600 text-sm">{role.future}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="bg-white rounded-2xl shadow-xl p-8"
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.6}}
        >
          <div className="flex items-center space-x-4 mb-6">
            <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiCpu} className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800">Certifieringar & kompetensutveckling</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-gray-800 mb-4">Rekommenderade certifieringar:</h4>
              <ul className="space-y-2">
                {certifications.map((cert,index)=> (
                  <li key={index} className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                    <span className="text-gray-700">{cert}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-lg">
              <h4 className="font-semibold text-gray-800 mb-3">Kom ihåg:</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Ta en certifiering även om det bara är det enklaste. Det visar att du kan slutföra uppgifter och är en bra person som följer igenom. Plus att det är säljbart!
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SkillsSection;